import type { ISakForsidefeed } from './ISakForsidefeed';
import { Sak } from './Sak';

export class SakForsidefeed implements ISakForsidefeed {
    public issues?: Array<Sak>;

    constructor(issues?: Array<Sak>) {
        this.issues = issues;
    }

    public static parse(data: ISakForsidefeed): SakForsidefeed {
        try {
            return new SakForsidefeed(
                data?.issues?.map((issue) => Sak.parseObject(issue)),
            );
        } catch (e) {
            throw new Error('Not able to parse object');
        }
    }
}
